import { RECOVERY_REASON } from "./renter.type";

export enum RENTER_VEHICLE_LINK_STATUS {
  ACTIVE = "active",
  FINALIZED = "finalized",
  REPOSSESSED = "repossessed",
  UNDEFINED = "undefined",
  RESCISION = "rescission",
}

export type PhotosSaved = {
  photosLinked: boolean;
  photosUnlinked: boolean;
}


export enum RENTER_LINK_TYPE {
  UNDEFINED = "undefined",
  ACTIVATION = "activation",
  REPOSSESSION = "repossession",
  RESCISION = "rescission",
  EXCHANGE = "exchange",
  RESERVE = "reserve",
  MIGRATION_SV = "migration_sv",
}

export type historyAction = {
  type: RENTER_LINK_TYPE;
  date: Date;
  autor: string;
}

export type DemagedPartType = {
  name: string;
  code: string;
  productOrWorkId: string;
  quantity: number;
  sellPrice: number;
}

export const emptyRenterRentalHistory = (): IRenterRentalHistory => ({
  _id: "",
  renterId: "",
  renterName: "",
  vehicleId: "",
  licensePlate: "",
  photosSaved: {
    photosLinked: false,
    photosUnlinked: false
  },
  vehicleVisualRecordId: "",
  repossessionId: "",
  reason: undefined,
  notes: "",
  status: RENTER_VEHICLE_LINK_STATUS.UNDEFINED,
  historyAction: [
    {
      type: RENTER_LINK_TYPE.UNDEFINED,
      date: new Date(),
      autor: "",
    }
  ],
  typeLink: RENTER_LINK_TYPE.UNDEFINED,
  companyId: "",
  partnerId: "",
  partnerCompanyName: "",
  unlinkedAt: new Date(),
  createdAt: new Date(),
  updatedAt: new Date(),
  damagedParts: [],
  withoutPhotos: false,
  returnReason: ""
})


export interface IRenterRentalHistory {
  _id?: string;
  renterId: string;
  renterName: string;
  vehicleId: string;
  licensePlate: string;
  partnerId?: string;
  partnerCompanyName?: string;
  photosSaved: PhotosSaved
  vehicleVisualRecordId?: string;
  repossessionId?: string;
  reason?: RECOVERY_REASON;
  notes: string;
  status: RENTER_VEHICLE_LINK_STATUS;
  typeLink?: RENTER_LINK_TYPE;
  historyAction: historyAction[];
  companyId?: string;
  unlinkedAt?: Date;
  createdAt: Date;
  updatedAt: Date;
  damagedParts?: DemagedPartType[];
  withoutPhotos: boolean;
  returnReason: string;
}